module.exports = __webpack_public_path__ + "static/media/shelf.e3acd386.svg";